import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Header,
  Home,
  About,
  Skills,
  Qualification,
  Services,
  Portfolio,
  Contact,
  Footer,
} from "./container";
import { ThemeProvider } from "./context/theme";
// UPDATE RESUME
// UPDATE FAVICON
// Convert app from ReactJS into NextJS
function App() {
  return (
    <ThemeProvider>
      {/* <CustomSlider /> */}
      <Header />
      <main className="main">
        <Home />
        <About />
        <Skills />
        <Qualification />
        <Portfolio />
        <Services />
        <Contact />
        {/* Recommendations
        Articles
        create backend with nextjs */}
      </main>
      <Footer />
      <ToastContainer />
    </ThemeProvider>
  );
}

export default App;
